import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { ConfettiComponent } from '@app/ui/confetti/confetti.component';
import { Observable } from 'rxjs';
import { OnboardingService, OnboardingStore } from '../../onboarding.service';

@Component({
  standalone: false,
  templateUrl: './onboarding-home.component.html',
  styleUrls: ['./onboarding-home.component.scss'],
})
export class OnboardingHomeComponent implements OnInit {
  loading: boolean;
  onboardingItems$: Observable<OnboardingStore> = this.onboardingService.onboardingItems;
  @ViewChild('confetti') confetti: ConfettiComponent;

  constructor(
    private readonly onboardingService: OnboardingService,
    private permissions: UserPermissionsService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.loading = true;

    this.preventSecondaryUsersFromAccessing();
  }

  preventSecondaryUsersFromAccessing() {
    this.permissions.loaded.subscribe((loaded) => {
      if (loaded) {
        this.permissions.isPrimaryUser().subscribe((isPrimaryUser) => {
          if (!isPrimaryUser) {
            this.router.navigate(['/dashboard']);
          } else {
            this.fetchOnboardingItems();
          }
        });
      }
    });
  }

  fetchOnboardingItems() {
    this.loading = true;
    this.onboardingService.getOnboardingItems(true).subscribe((res) => {
      this.loading = false;

      if (res.meta?.has_changes_since_last_seen) {
        // something changed since the user last visited the page, fire off the confetti canon
        this.confetti.fireConfetti();
      }
    });
  }
}
